module.exports = __webpack_public_path__ + "img/login.50d63861.png";